export const WINDOW_HOURS_OPTIONS = [1, 2, 6, 24]
export const DEFAULT_WINDOW_HOURS = 2
export const REFRESH_INTERVAL_MS = 60_000

/** Failure share above which the rate is shown in red. Tune after watching a normal day. */
export const FAILURE_RATE_ALERT_THRESHOLD = 0.1

export type HealthStat = {
  label: string
  value: string
  /** Shows the value in red. */
  alert?: boolean
}

export const formatRate = (rate: number): string => `${(rate * 100).toFixed(1)}%`

/** Game picker value for every game; Radix Select items can't use an empty value. */
export const ALL_GAMES = 'all'

export enum HealthTab {
  SPINS = 'spins',
  SCANS = 'scans',
}

/** URL search params that hold the page's settings, so links away and back return to the same view. */
export enum HealthSearchParam {
  TAB = 'tab',
  WINDOW = 'window',
  GAME = 'game',
}
